import { DataModelBuilder, isSameData, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { LocalizedString } from '../../models/serializable/localized-string.js';
import { PhotoReference } from '../../models/serializable/file-reference/photo-reference.js';
import { MapUtils } from '../../utility/map-utils.js';
import { RenderableComponent } from '../core/component.js';

/**
 * @deprecated Use `ResponsiveImageComponent' instead.
 */
export class LegacyResponsiveImageComponent extends RenderableComponent {
  static readonly TYPE_ID: string = 'ecff8e404d49477d974e96a9fff87449';
  static readonly DEFAULT_RENDER_ORDER: number = 14;

  constructor(
    public readonly titles: LocalizedString,
    public readonly photo: PhotoReference | null,
    public readonly renderOrder: number,
    public readonly isRenderingEnabled: boolean,
  ) {
    super();
  }

  get $typeId(): string {
    return LegacyResponsiveImageComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return true;
  }

  static fromMap(context: SerializationContext, map: SerializedData): LegacyResponsiveImageComponent {
    return new LegacyResponsiveImageComponent(
        context.fromData<LocalizedString>(MapUtils.get<SerializedData>(map, 'titles')),
        context.fromDataOrNull<PhotoReference>(MapUtils.getOrNull<SerializedData>(map, 'photo')),
        MapUtils.get<number>(map, 'renderOrder'),
        MapUtils.get<boolean>(map, 'isRenderingEnabled'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'titles': context.toData(this.titles),
      'photo': context.toDataOrNull(this.photo),
      'renderOrder': this.renderOrder,
      'isRenderingEnabled': this.isRenderingEnabled,
    };
  }

  clone(): this {
    return new LegacyResponsiveImageComponent(
        this.titles.clone(),
        this.photo?.clone() ?? null,
        this.renderOrder,
        this.isRenderingEnabled
    ) as this;
  }

  isSame(other: LegacyResponsiveImageComponent): boolean {
    if(other === this) {
      return true;
    }

    return isSameData(other.titles, this.titles) &&
      isSameData(other.photo, this.photo) &&
      other.renderOrder === this.renderOrder &&
      other.isRenderingEnabled === this.isRenderingEnabled;
  }
}

export class LegacyResponsiveImageComponentBuilder extends DataModelBuilder<LegacyResponsiveImageComponent> {
  build(context: SerializationContext, map: SerializedData): LegacyResponsiveImageComponent {
    return LegacyResponsiveImageComponent.fromMap(context, map);
  }
}
